import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { nextTick } from 'vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/login',
    children: [{
      path: '/quickEntry',
      name: 'Echart',
      navTitle: '首页',
      component: () => import('@/views/Page/quickEntry.vue')
    }, {
      path: '/h5HomePage',
      name: 'h5HomePage',
      navTitle: 'h5首页',
      component: () => import('@/views/Page/h5HomePage.vue')
    }, {
      path: '/notice',
      name: 'notice',
      title: '通知公告',
      component: () => import('@/views/NoticeAndFile/notice.vue'),
    }, {
      path: '/sendNotice',
      name: 'sendNotice',
      title: '通知公告',
      component: () => import('@/views/NoticeAndFile/sendNotice.vue'),
    }, {
      path: '/file',
      name: 'file',
      title: '文件发布',
      component: () => import('@/views/NoticeAndFile/file.vue')
    }, {
      path: '/fileOnlyDownload',
      name: 'fileOnlyDownload',
      title: '文件下载',
      component: () => import('@/views/NoticeAndFile/fileOnlyDownload.vue')
    }, {
      path: '/trainingRoom',
      name: 'trainingRoom',
      title: '实验实训室管理',
      component: () => import('@/views/BaseInfo/trainingRoom.vue'),
      children: [
        {
          path: 'trainingRoomToEq',
          component: () => import('@/views/BaseInfo/trainingRoomToEq.vue')
        },
      ]
    },
    // {
    //   path: '/trainingRoomDetail',
    //   name: 'trainingRoomDetail',
    //   title: '实验实训室院系详情',
    //   component: () => import('@/views/BaseInfo/trainingRoomDetail.vue'),
    // }, 
    {
      path: '/trainRoomByStructure',
      name: 'trainRoomByStructure',
      title: '实验实训室院系汇总',
      component: () => import('@/views/BaseInfo/trainRoomByStructure.vue'),
      redirect: '/trainRoomByStructure/list',
      children: [
        {
          path: 'detail',
          component: () => import('@/views/BaseInfo/detail.vue')
        },
        {
          path: 'list',
          component: () => import('@/views/BaseInfo/list.vue')
        },
      ]
    },
    // {
    //   path: '/trainingRoomToEq',
    //   name: 'trainingRoomToEq',
    //   title: '实验实训室设备管理',
    //   component: () => import('@/views/BaseInfo/trainingRoomToEq.vue')
    // },
    {
      path: '/trainingRoomToSafe',
      name: 'trainingRoomToSafe',
      title: '实验实训室安全管理',
      component: () => import('@/views/BaseInfo/trainingRoomToSafe.vue')
    },
    {
      path: '/safeCourse',
      name: 'safeCourse',
      title: '在线安全考试课程管理',
      component: () => import('@/views/SafeManage/safeCourse.vue')
    },
    {
      path: '/safeCourseScore',
      name: 'safeCourseScore',
      title: '安全课程成绩统计',
      component: () => import('@/views/SafeManage/safeCourseScore.vue')
    },
    {
      path: '/TrainPlan',
      name: 'TrainPlan',
      title: '授课计划导入及维护',
      component: () => import('@/views/CourseManage/trainPlan.vue'),
    },
    {
      path: '/courseManage',
      name: 'courseManage',
      title: '课程管理',
      component: () => import('@/views/CourseManage/courseManage.vue')
    },
    {
      path: '/courseMaterialsManage',
      name: 'courseMaterialsManage',
      title: '课程资料管理',
      component: () => import('@/views/CourseManage/courseMaterialsManage.vue')
    },
    {
      path: '/teacherAttendance',
      name: 'teacherAttendance',
      title: '老师考勤',
      component: () => import('@/views/CourseManage/teacherAttendance.vue')
    },
    {
      path: '/studentAttendance',
      name: 'studentAttendance',
      title: '学生考勤',
      component: () => import('@/views/CourseManage/studentAttendance.vue')
    },
    {
      path: '/courseProjectsMange',
      name: 'courseProjectsMange',
      component: () => import('@/views/CourseManage/courseProjectsMange.vue')
    },
    {
      path: '/courseProjectsMangeAudit',
      name: 'courseProjectsMangeAudit',
      component: () => import('@/views/CourseManage/courseProjectsMangeAudit.vue')
    },
    {
      path: '/courseProjectsMangeTeacher',
      name: 'courseProjectsMangeTeacher',
      component: () => import('@/views/CourseManage/courseProjectsMangeTeacher.vue')
    },
    {
      path: '/sydg',
      name: 'sydg',
      title: '大纲',
      component: () => import('@/views/CourseManage/sydg.vue')
    },
    {
      path: '/processManage',
      name: 'processManage',
      title: '实训过程管理',
      component: () => import('@/views/Process/processManage.vue')
    },
    {
      path: '/trainConect',
      name: 'trainConect',
      title: '实训通信',
      component: () => import('@/views/Conect/trainConect.vue')
    },
    {
      path: '/awardsList',
      name: 'awardsList',
      title: '实训获奖',
      component: () => import('@/views/awards/awardsList.vue')
    },
    {
      path: '/dataAnalysis',
      name: 'dataAnalysis',
      title: '实训课数据分析',
      component: () => import('@/views/DataAnalysis/dataAnalysis.vue')
    },
    {
      path: '/courseManageForTeracher',
      name: 'courseManageForTeracher',
      title: '我的课程',
      component: () => import('@/views/CourseManage/courseManageForTeracher.vue')
    },
    {
      path: '/courseManageImport',
      name: 'courseManageImport',
      title: '课程导入',
      component: () => import('@/views/CourseManage/courseManageImport.vue')
    },
    {
      path: '/courseManageAudit',
      name: 'courseManageAudit',
      title: '课程管理审批',
      component: () => import('@/views/CourseManage/courseManageAudit.vue')
    },
    {
      path: '/addCourseForNowTC',
      name: 'addCourseForNowTC',
      title: '临时加课（老师）',
      component: () => import('@/views/CourseManage/addCourseForNowTC.vue')
    },
    {
      path: '/addCourseForNowAD',
      name: 'addCourseForNowAD',
      title: '临时加课（管理员）',
      component: () => import('@/views/CourseManage/addCourseForNowAD.vue')
    }, {
      path: '/TrainAppoint',
      name: 'TrainAppoint',
      title: '实验实训室安排',
      component: () => import('@/views/TrainAppoint/trainAppoint.vue'),
    },
    {
      path: '/appointmentManageTC',
      name: 'appointmentManageTC',
      title: '预约管理（老师）',
      component: () => import('@/views/TrainAppoint/appointmentManageTC.vue')
    },
    {
      path: '/appointRule',
      name: 'appointRule',
      title: '预约规则',
      component: () => import('@/views/TrainAppoint/appointRule.vue')
    },
    {
      path: '/appointCount',
      name: 'appointCount',
      title: '预约统计',
      component: () => import('@/views/TrainAppoint/appointCount.vue')
    }, {
      path: '/certificatesMine',
      name: 'certificatesMine',
      component: () => import('@/views/skill/certificatesMine.vue'),
    }, {
      path: '/certificates',
      name: 'certificates',
      component: () => import('@/views/skill/certificates.vue'),
    },
    {
      path: '/appointLibrary',
      name: 'appointLibrary',
      title: '图书馆预约管理',
      component: () => import('@/views/TrainAppoint/appointLibrary.vue')
    },
    {
      path: '/appointMeeting',
      name: 'appointMeeting',
      title: '会议室预约管理',
      component: () => import('@/views/TrainAppoint/appointMeeting.vue')
    },
    {
      path: '/appointVenue',
      name: 'appointVenue',
      title: '场馆预约',
      component: () => import('@/views/TrainAppoint/appointVenue.vue')
    },
    {
      path: '/approveLibrary',
      name: 'approveLibrary',
      title: '图书馆预约审核',
      component: () => import('@/views/TrainAppoint/approveLibrary.vue')
    },
    {
      path: '/approveMeeting',
      name: 'approveMeeting',
      title: '会议室预约审核',
      component: () => import('@/views/TrainAppoint/approveMeeting.vue')
    },
    {
      path: '/approveVenue',
      name: 'approveVenue',
      title: '场馆预约审核',
      component: () => import('@/views/TrainAppoint/approveVenue.vue')
    },
    {
      path: '/appointmentManageAD',
      name: 'appointmentManageAD',
      title: '预约管理（管理员）',
      component: () => import('@/views/TrainAppoint/appointmentManageAD.vue')
    }
      // , 
      // {
      //   path: '/TrainAppoint',
      //   name: 'TrainAppoint',
      //   index: 5,
      //   navTitle: '实验实训室预约管理',
      //   navIcon: 'el-icon-menu',
      //   component: () => import( '@/views/courseManage/TrainAppoint.vue')
      // }
      , {
      path: '/StudentSign',
      name: 'StudentSign',
      title: '学生课堂出勤统计',
      component: () => import('@/views/StudentSign/signs.vue'),
    }
      // , 
      // {
      //   path: '/appointmentManageTC',
      //   name: 'appointmentManageTC',
      //   index: 6.1,
      //   pindex: 6,
      //   title: '预约管理（老师）',
      //   icon: 'el-icon-s-operation',
      //   component: () => import( '@/views/TrainAppoint/appointmentManageTC.vue')
      // }
      , {
      path: '/EvaluateManage',
      name: 'EvaluateManage',
      title: '教学评价及成绩汇总',
      component: () => import('@/views/EvaluateManage/evaluateManage.vue'),
    }
      , {
      path: '/Journals',
      name: 'Journals',
      title: '实训日志提交及汇总',
      component: () => import('@/views/JournalManage/journals.vue'),
    }, {
      path: '/journalsMine',
      name: 'journalsMine',
      title: '我的实训日志',
      component: () => import('@/views/JournalManage/journalsMine.vue'),
    }, {
      path: '/JournalOfClass',
      name: 'JournalOfClass',
      title: '实训课堂日志',
      component: () => import('@/views/JournalManage/journalOfClass.vue')
    }, {
      path: '/JournalOfEqSX',
      name: 'JournalOfEqSX',
      title: '设备交接日志（实训老师）',
      component: () => import('@/views/JournalManage/journalOfEqSX.vue')
    }, {
      path: '/JournalOfEqSK',
      name: 'JournalOfEqSK',
      title: '设备交接日志（授课老师）',
      component: () => import('@/views/JournalManage/journalOfEqSK.vue')
    }, {
      path: '/EquipmentInto',
      name: 'EquipmentInto',
      title: '实训设备入库',
      component: () => import('@/views/EquipmentManage/equipmentInto.vue'),
    }, {
      path: '/EquipmentJY',
      name: 'EquipmentJY',
      title: '实训设备借用',
      component: () => import('@/views/EquipmentManage/equipmentJY.vue'),
    }, {
      path: '/equipmentJYMine',
      name: 'equipmentJYMine',
      title: '我的设备借用申请',
      component: () => import('@/views/EquipmentManage/equipmentJYMine.vue'),
    }, {
      path: '/equipmentAplplyOper',
      name: 'equipmentAplplyOper',
      title: '我的设备借用申请',
      component: () => import('@/views/EquipmentManage/equipmentAplplyOper.vue'),
    }, {
      path: '/equipmentInventory',
      name: 'equipmentInventory',
      title: '仪器设备库存管理',
      component: () => import('@/views/EquipmentManage/equipmentInventory.vue'),
    }, {
      path: '/equipmentIntoRecord',
      name: 'equipmentIntoRecord',
      title: '仪器设备入库记录',
      component: () => import('@/views/EquipmentManage/equipmentIntoRecord.vue'),
    }, {
      path: '/EquipmentBuy',
      name: 'EquipmentBuy',
      title: '实训设备采购管理',
      component: () => import('@/views/EquipmentManage/equipmentBuy.vue'),
    }, {
      path: '/equipmentBuyMine',
      name: 'equipmentBuyMine',
      title: '实训设备采购申请',
      component: () => import('@/views/EquipmentManage/equipmentBuyMine.vue'),
    }, {
      path: '/EquipmentScrap',
      name: 'EquipmentScrap',
      title: '实训设备报废',
      component: () => import('@/views/EquipmentManage/equipmentScrap.vue')
    }, {
      path: '/equipmentScrapOper',
      name: 'equipmentScrapOper',
      title: '实训设备报废审批',
      component: () => import('@/views/EquipmentManage/equipmentScrapOper.vue')
    }, {
      path: '/EquipmentFixed',
      name: 'EquipmentFixed',
      title: '实训设备维修',
      component: () => import('@/views/EquipmentManage/equipmentFixed.vue')
    }, {
      path: '/equipmentFixedOper',
      name: 'equipmentFixedOper',
      title: '实训设备维修审批',
      component: () => import('@/views/EquipmentManage/equipmentFixedOper.vue')
    }, {
      path: '/EquipmentMaintain',
      name: 'EquipmentMaintain',
      title: '实训设备维护',
      component: () => import('@/views/EquipmentManage/equipmentMaintain.vue')
    }, {
      path: '/equipmentMaintainOper',
      name: 'equipmentMaintainOper',
      title: '实训设备维护审批',
      component: () => import('@/views/EquipmentManage/equipmentMaintainOper.vue')
    }, {
      path: '/EquipmentBorrowIn',
      name: 'EquipmentBorrowIn',
      title: '实训设备借入',
      component: () => import('@/views/EquipmentManage/equipmentBorrowIn.vue')
    }, {
      path: '/EquipmentBorrowOut',
      name: 'EquipmentBorrowOut',
      title: '实训设备借出',
      component: () => import('@/views/EquipmentManage/equipmentBorrowOut.vue')
    }, {
      path: '/EquipmentBorrowBack',
      name: 'EquipmentBorrowBack',
      title: '实训设备清还',
      component: () => import('@/views/EquipmentManage/equipmentBorrowBack.vue')
    }, {
      path: '/EquipmentCounts',
      name: 'EquipmentCounts',
      title: '实训设备总帐明细',
      component: () => import('@/views/EquipmentManage/equipmentCounts.vue')
    }, {
      path: '/equipmentCountsByStructure',
      name: 'equipmentCountsByStructure',
      title: '实训设备院系汇总',
      component: () => import('@/views/EquipmentManage/equipmentCountsByStructure.vue')
    }, {
      path: '/equipmentCountsWithMajor',
      name: 'equipmentCountsWithMajor',
      title: '实训设备院系汇总',
      component: () => import('@/views/EquipmentManage/equipmentCountsWithMajor.vue')
    }, {
      path: '/consumablePurchase',
      name: 'consumablePurchase',
      title: '实训耗材采购审批',
      component: () => import('@/views/Consumable/consumablePurchase.vue'),
    }, {
      path: '/consumablePurchaseMine',
      name: 'consumablePurchaseMine',
      title: '实训耗材采购',
      component: () => import('@/views/Consumable/consumablePurchaseMine.vue'),
    }, {
      path: '/ConsumableInto',
      name: 'ConsumableInto',
      title: '实训耗材入库',
      component: () => import('@/views/Consumable/consumableInto.vue'),
    }, {
      path: '/consumableBorrow',
      name: 'consumableBorrow',
      title: '实训耗材领用',
      component: () => import('@/views/Consumable/consumableBorrow.vue'),
    }, {
      path: '/consumableBorrowOper',
      name: 'consumableBorrowOper',
      title: '实训耗材领用',
      component: () => import('@/views/Consumable/consumableBorrowOper.vue'),
    }, {
      path: '/ConsumableUse',
      name: 'ConsumableUse',
      title: '易耗品使用登记',
      component: () => import('@/views/Consumable/consumableUse.vue')
    }, {
      path: '/ConsumableSurplus',
      name: 'ConsumableSurplus',
      title: '实训耗材剩余汇总',
      component: () => import('@/views/Consumable/consumableSurplus.vue')
    }, {
      path: '/consumableSurplusByStructure',
      name: 'consumableSurplusByStructure',
      title: '实训耗材院系汇总',
      component: () => import('@/views/Consumable/consumableSurplusByStructure.vue')
    }, {
      path: '/consumableSurplusWithMajor',
      name: 'consumableSurplusWithMajor',
      title: '实训耗材院系汇总详情',
      component: () => import('@/views/Consumable/consumableSurplusWithMajor.vue')
    }
      , {
      path: '/chemicalInventory',
      name: 'chemicalInventory',
      title: '化学品库存管理',
      component: () => import('@/views/Chemical/chemicalInventory.vue'),
    }, {
      path: '/chemicalIntoRecord',
      name: 'chemicalIntoRecord',
      title: '化学品入库记录',
      component: () => import('@/views/Chemical/chemicalIntoRecord.vue'),
    }, {
      path: '/chemicalDisposal',
      name: 'chemicalDisposal',
      title: '化学品废弃记录',
      component: () => import('@/views/Chemical/chemicalDisposal.vue'),
    }, {
      path: '/chemicalBuyMine',
      name: 'chemicalBuyMine',
      title: '化学品采购申请',
      component: () => import('@/views/Chemical/chemicalBuyMine.vue'),
    }, {
      path: '/chemicalBuyOper',
      name: 'chemicalBuyOper',
      title: '化学品采购申请审批',
      component: () => import('@/views/Chemical/chemicalBuyOper.vue'),
    }, {
      path: '/chemicalBorrow',
      name: 'chemicalBorrow',
      title: '化学品领用申请',
      component: () => import('@/views/Chemical/chemicalBorrow.vue'),
    }, {
      path: '/chemicalUse',
      name: 'chemicalUse',
      title: '化学品出库登记',
      component: () => import('@/views/Chemical/chemicalUse.vue'),
    },{
      path: '/chemicalBorrowOper',
      name: 'chemicalBorrowOper',
      title: '化学品领用审批',
      component: () => import('@/views/Chemical/chemicalBorrowOper.vue'),
    }, {
      path: '/DataReport',
      name: 'DataReport',
      title: '数据统计报表',
      component: () => import('@/views/DataReport/dataReport.vue'),
    }, {
      path: '/dataStatistics',
      name: 'dataStatistics',
      title: '实训室可视化数据统计',
      component: () => import('@/views/DataReport/dataStatistics.vue'),
    },{
      path: '/ExecelImport',
      name: 'ExecelImport',
      title: '数据导入Demo',
      component: () => import('@/views/SystemSet/execelImport.vue'),
    }, {
      path: '/RoleManage',
      name: 'RoleManage',
      title: '角色管理',
      component: () => import('@/views/SystemSet/roleManage.vue'),
    }, {
      path: '/webSiteStyle',
      name: 'webSiteStyle',
      title: '个性化设置',
      component: () => import('@/views/SystemSet/webSiteStyle.vue'),
    }, {
      path: '/organManage',
      name: 'organManage',
      title: '组织结构管理',
      component: () => import('@/views/SystemSet/organManage.vue'),
    }, {
      path: '/userList',
      name: 'userList',
      title: '用户管理',
      component: () => import('@/views/UserManage/userList.vue'),
    }, {
      path: '/qulityEval',
      name: 'qulityEval',
      title: '教学质量评价',
      component: () => import('@/views/QulityEval/qulityEval.vue'),
    }, {
      path: '/qulityItemSet',
      name: 'qulityItemSet',
      title: '教学评价模板设置',
      component: () => import('@/views/QulityEval/qulityItemSet.vue'),
      meta: {
        keepAlive: true // 需要被缓存
      }
    }, {
      path: '/qulityGrade',
      name: 'qulityGrade',
      title: '实训课成绩汇总',
      component: () => import('@/views/QulityEval/qulityGrade.vue'),
    }, {
      path: '/qulityAdvice',
      name: 'qulityAdvice',
      title: '实训课评价汇总',
      component: () => import('@/views/QulityEval/qulityAdvice.vue'),
    }, {
      path: '/studentClasss',
      name: 'studentClasss',
      title: '学生实训课列表',
      component: () => import('@/views/StudentTraClasss/studentClasss.vue'),
    }, {
      path: '/adminPlane',
      name: 'adminPlane',
      title: '实训计划列表',
      component: () => import('@/views/TrainPlan/adminPlane.vue'),
    }, {
      path: '/teacherPlane',
      name: 'teacherPlane',
      title: '实训计划列表',
      component: () => import('@/views/TrainPlan/teacherPlane.vue'),
    }, {
      path: '/studentPlane',
      name: 'studentPlane',
      title: '可报名实训计划列表',
      component: () => import('@/views/TrainPlan/studentPlane.vue'),
    }, {
      path: '/studentPlaneAlreadyApply',
      name: 'studentPlaneAlreadyApply',
      title: '已报名实训计划列表',
      component: () => import('@/views/TrainPlan/studentPlaneAlreadyApply.vue'),
    }, {
      path: '/tstudentPlanes',
      name: 'tstudentPlanes',
      title: '学生实训计划申请',
      component: () => import('@/views/TrainPlan/tstudentPlanes.vue'),
    }, {
      path: '/planMark',
      name: 'planMark',
      title: '学生实训计划成绩',
      component: () => import('@/views/TrainPlan/planMark.vue'),
    }, {
      path: '/trainItemConfig',
      name: 'trainItemConfig',
      title: '实训计划打分模板配置',
      component: () => import('@/views/TrainPlan/trainItemConfig.vue'),
    }, {
      path: '/trainBaseList',
      name: 'trainBaseList',
      title: '实训基地配置',
      component: () => import('@/views/TrainBase/trainBaseList.vue'),
    }, {
      path: '/messages',
      name: 'messages',
      title: '我的消息',
      component: () => import('@/views/NoticeAndFile/messages.vue'),
    }, {
      path: '/schoolConfig',
      name: 'schoolConfig',
      title: '学校管理',
      component: () => import('@/views/SchoolManage/schoolConfig.vue'),
    }, {
      path: '/trainRoomOpen',
      name: 'trainRoomOpen',
      title: '实验实训室开放管理',
      component: () => import('@/views/BaseInfo/trainRoomOpen.vue'),
    }, {
      path: '/trainRoomOpenCase',
      name: 'trainRoomOpenCase',
      title: '实验实训室开放情况管理',
      component: () => import('@/views/BaseInfo/trainRoomOpenCase.vue'),
    }, {
      path: '/trainRoomManagers',
      name: 'trainRoomManagers',
      title: '专任实验室人员管理',
      component: () => import('@/views/BaseInfo/trainRoomManagers.vue'),
    }, {
      path: '/trainRoomComputerUseed',
      name: 'trainRoomComputerUseed',
      title: '实验实训室计算机使用情况',
      component: () => import('@/views/BaseInfo/trainRoomComputerUseed.vue'),
    }, {
      path: '/trainRoomComputerCount',
      name: 'trainRoomComputerCount',
      title: '实验实训室计算机统计',
      component: () => import('@/views/BaseInfo/trainRoomComputerCount.vue'),
    }, {
      path: '/trainRoomFunds',
      name: 'trainRoomFunds',
      title: '实验实训室经费数据情况',
      component: () => import('@/views/BaseInfo/trainRoomFunds.vue'),
    }, {
      path: '/trainOutBaseList',
      name: 'trainOutBaseList',
      title: '校外实训基地列表',
      component: () => import('@/views/TrainBase/trainOutBaseList.vue'),
    }, {
      path: '/trainOutItemConfig',
      name: 'trainOutItemConfig',
      title: '校外实验实训室打分配置',
      component: () => import('@/views/TrainBase/trainOutItemConfig.vue'),
    }, {
      path: '/trainOutStudent',
      name: 'trainOutStudent',
      title: '校外实训基地学生统计',
      component: () => import('@/views/TrainBase/trainOutStudent.vue'),
    }, {
      path: '/trainCourseScore',
      name: 'trainCourseScore',
      title: '实训课成绩评价',
      component: () => import('@/views/QulityEval/trainCourseScore.vue'),
    }, {
      path: '/studentApply',
      name: 'studentApply',
      title: '实训资源开放预约',
      component: () => import('@/views/openAppointment/studentApply.vue'),
    }, {
      path: '/teacherOperApply',
      name: 'teacherOperApply',
      title: '学生开放预约处理',
      component: () => import('@/views/openAppointment/teacherOperApply.vue'),
    }, {
      path: '/openTariningRooms',
      name: 'openTariningRooms',
      title: '已预约实验实训室时间列表',
      component: () => import('@/views/openAppointment/openTariningRooms.vue'),
    }, {
      path: '/dangerGoods',
      name: 'dangerGoods',
      title: '危化品管理',
      component: () => import('@/views/DangersManage/dangerGoods.vue'),
    }, {
      path: '/dangerGoodsForTeacher',
      name: 'dangerGoodsForTeacher',
      title: '危化品借用',
      component: () => import('@/views/DangersManage/dangerGoodsForTeacher.vue'),
    }, {
      path: '/danGoodsAplplyOper',
      name: 'danGoodsAplplyOper',
      title: '危化品借用申请处理',
      component: () => import('@/views/DangersManage/danGoodsAplplyOper.vue'),
    }, {
      path: '/danGoodsApplyMine',
      name: 'danGoodsApplyMine',
      title: '我的危化品借用申请',
      component: () => import('@/views/DangersManage/danGoodsApplyMine.vue'),
    }, {
      path: '/dangerGoodsLog',
      name: 'dangerGoodsLog',
      title: '危化品使用日志',
      component: () => import('@/views/DangersManage/dangerGoodsLog.vue'),
    }, {
      path: '/dangerGoodsLogMine',
      name: 'dangerGoodsLogMine',
      title: '我的危化品使用日志',
      component: () => import('@/views/DangersManage/dangerGoodsLogMine.vue'),
    }, {
      path: '/dangerGoodsPurchase',
      name: 'dangerGoodsPurchase',
      title: '危化品采购申请',
      component: () => import('@/views/DangersManage/dangerGoodsPurchase.vue'),
    }, {
      path: '/dangerGoodsPurchaseMine',
      name: 'dangerGoodsPurchaseMine',
      title: '我的危化品采购申请',
      component: () => import('@/views/DangersManage/dangerGoodsPurchaseMine.vue'),
    }, {
      path: '/studentSignCourse',
      name: 'studentSignCourse',
      title: '学生实训课列表',
      component: () => import('@/views/TrainSign/studentSignCourse.vue'),
    }, {
      path: '/teacherSignCoure',
      name: 'teacherSignCoure',
      title: '实训课考勤情况',
      component: () => import('@/views/TrainSign/teacherSignCoure.vue'),
    }, {
      path: '/breakRecord',
      name: 'breakRecord',
      title: '开放资源使用违规记录',
      component: () => import('@/views/openAppointment/breakRecord.vue'),
    }, {
      path: '/openResourceManage',
      name: 'openResourceManage',
      title: '开放资源管理',
      component: () => import('@/views/openAppointment/openResourceManage.vue'),
    }, {
      path: '/journalsOperate',
      name: 'journalsOperate',
      title: '系统操作日志',
      component: () => import('@/views/JournalManage/journalsOperate.vue'),
    }, {
      path: '/journalsLogin',
      name: 'journalsLogin',
      title: '系统登录日志',
      component: () => import('@/views/JournalManage/journalsLogin.vue'),
    }, {
      path: '/standardList',
      name: 'standardList',
      title: '指标库列表',
      component: () => import('@/views/Standard/standardList.vue'),
    }, {
      path: '/safeCheckActivity',
      name: 'safeCheckActivity',
      title: '安全巡查活动列表',
      component: () => import('@/views/Standard/safeCheckActivity.vue'),
    }, {
      path: '/hazardRectification',
      name: 'hazardRectification',
      component: () => import('@/views/Standard/hazardRectification.vue'),
    }, {
      path: '/hazardRectificationOper',
      name: 'hazardRectificationOper',
      component: () => import('@/views/Standard/hazardRectificationOper.vue'),
    }, {
      path: '/quickPhoto',
      name: 'quickPhoto',
      component: () => import('@/views/Standard/quickPhoto.vue'),
    }, {
      path: '/quickPhotoOper',
      name: 'quickPhotoOper',
      component: () => import('@/views/Standard/quickPhotoOper.vue'),
    }, {
      path: '/safeCheckActivityResUp',
      name: 'safeCheckActivityResUp',
      title: '安全巡查结果上报',
      component: () => import('@/views/Standard/safeCheckActivityResUp.vue'),
    }, {
      path: '/safeItemCheckActivity',
      name: 'safeItemCheckActivity',
      title: '专项检查活动列表',
      component: () => import('@/views/Standard/safeItemCheckActivity.vue'),
    }, {
      path: '/safeItemCheckActivityResUp',
      name: 'safeItemCheckActivityResUp',
      title: '专项检查结果上报',
      component: () => import('@/views/Standard/safeItemCheckActivityResUp.vue'),
    }, {
      path: '/safeSelfCheckActivity',
      name: 'safeSelfCheckActivity',
      title: '安全自查活动列表',
      component: () => import('@/views/Standard/safeSelfCheckActivity.vue'),
    }, {
      path: '/safeSelfCheckActivityResUp',
      name: 'safeSelfCheckActivityResUp',
      title: '安全自查活动上报',
      component: () => import('@/views/Standard/safeSelfCheckActivityResUp.vue'),
    }, {
      path: '/checkTable',
      name: 'checkTable',
      title: '检查表列表',
      component: () => import('@/views/Standard/checkTable.vue'),
    }, {
      path: '/checkRecordTable',
      name: 'checkRecordTable',
      title: '检查记录表列表',
      component: () => import('@/views/Standard/checkRecordTable.vue'),
    }, {
      path: '/troubles',
      name: 'troubles',
      title: '安全隐患列表',
      component: () => import('@/views/Standard/troubles.vue'),
    }, {
      path: '/troubleAplplyOper',
      name: 'troubleAplplyOper',
      title: '安全隐患整改结果处理',
      component: () => import('@/views/Standard/troubleAplplyOper.vue'),
    }, {
      path: '/troubleAplplyMIne',
      name: 'troubleAplplyMIne',
      title: '我的安全隐患整改结果',
      component: () => import('@/views/Standard/troubleAplplyMIne.vue'),
    }, {
      path: '/freePhotoOper',
      name: 'freePhotoOper',
      title: '随手拍处理',
      component: () => import('@/views/Standard/freePhotoOper.vue'),
    }, {
      path: '/checkActivities',
      name: 'checkActivities',
      title: '巡查活动列表',
      component: () => import('@/views/Standard/checkActivities.vue'),
    }, {
      path: '/trainingLevel',
      name: 'trainingLevel',
      title: '实验实训室分级管理',
      component: () => import('@/views/BaseInfo/trainingLevel.vue'),
    }, {
      path: '/trainingItem',
      name: 'trainingItem',
      title: '实验实训室建设项目管理',
      component: () => import('@/views/BaseInfo/trainingItem.vue'),
    }, {
      path: '/trainingItemOper',
      name: 'trainingItemOper',
      title: '实验实训室建设项目处理',
      component: () => import('@/views/BaseInfo/trainingItemOper.vue'),
    }, {
      path: '/yearSafeReport',
      name: 'yearSafeReport',
      title: '实验实训室安全工作年度报告',
      component: () => import('@/views/BaseInfo/yearSafeReport.vue'),
    }, {
      path: '/yearSafeReportCount',
      name: 'yearSafeReportCount',
      title: '实验实训室安全工作年度报告汇总',
      component: () => import('@/views/BaseInfo/yearSafeReportCount.vue'),
    }, {
      path: '/hugeDeviceUses',
      name: 'hugeDeviceUses',
      title: '实验实训室大型仪器设备使用',
      component: () => import('@/views/EquipmentManage/hugeDeviceUses.vue'),
    }, {
      path: '/hugeDeviceAcemtUp',
      name: 'hugeDeviceAcemtUp',
      title: '实验实训室大型仪器设备成果上报',
      component: () => import('@/views/EquipmentManage/hugeDeviceAcemtUp.vue'),
    }, {
      path: '/hugeDeviceAppointment',
      name: 'hugeDeviceAppointment',
      title: '实验实训室大型仪器设备预约',
      component: () => import('@/views/EquipmentManage/hugeDeviceAppointment.vue'),
    }, {
      path: '/hugeDeviceAppointmentOper',
      name: 'hugeDeviceAppointmentOper',
      title: '实验实训室大型仪器设备审批',
      component: () => import('@/views/EquipmentManage/hugeDeviceAppointmentOper.vue'),
    }, {
      path: '/hugeDeviceOpen',
      name: 'hugeDeviceOpen',
      title: '实验实训室大型仪器设备开放管理',
      component: () => import('@/views/EquipmentManage/hugeDeviceOpen.vue'),
    }, {
      path: '/bigDevices',
      name: 'bigDevices',
      title: '实验实训室大型仪器设备管理',
      component: () => import('@/views/EquipmentManage/bigDevices.vue'),
    }, {
      path: '/bigDevicesbook',
      name: 'bigDevicesbook',
      title: '实验实训室大型仪器设备预约',
      component: () => import('@/views/EquipmentManage/bigDevicesbook.vue'),
    }, {
      path: '/bigDevicesbookOper',
      name: 'bigDevicesbookOper',
      title: '实验实训室大型仪器设备预约处理',
      component: () => import('@/views/EquipmentManage/bigDevicesbookOper.vue'),
    },
    {
      path: '/freePhotoMine',
      name: 'freePhotoMine',
      title: '我的随手拍',
      component: () => import('@/views/Standard/freePhotoMine.vue'),
    },
    {
      path: '/TermManage',
      name: 'TermManage',
      title: '学期管理',
      component: () => import('@/views/SystemSet/TermManage.vue'),
    },
    {
      path: '/periodManage',
      name: 'periodManage',
      title: '节次管理',
      component: () => import('@/views/SystemSet/periodManage.vue'),
    },
    {
      path: '/dcwj',
      name: 'dcwj',
      title: '问卷测评管理',
      component: () => import('@/views/Dcwj/dcwj.vue'),
    },
    {
      path: '/questionManage',
      name: 'questionManage',
      title: '试卷配置',
      component: () => import('@/views/Dcwj/questionManage.vue'),
    },
    {
      path: '/questionItemManage',
      name: 'questionItemManage',
      title: '题目配置',
      component: () => import('@/views/Dcwj/questionItemManage.vue'),
    },
    {
      path: '/questionBank',
      name: 'questionBank',
      title: '题库管理',
      component: () => import('@/views/Dcwj/questionBank.vue'),
    },
    {
      path: '/dcwjTest',
      name: 'dcwjTest',
      title: '学生问卷测评',
      component: () => import('@/views/Dcwj/dcwjTest.vue'),
    },
    {
      path: '/ai-robot',
      name: 'ai-robot',
      title: 'AI实验实训助手',
      component: () => import('@/views/Ai/ai-robot.vue'),
    },
    {
      path: '/ai-test',
      name: 'ai-test',
      title: 'AI实验实训助手',
      component: () => import('@/views/Ai/ai-test.vue'),
    },
    {
      path: '/learnSafeCourse',
      name: 'learnSafeCourse',
      title: '在线安全课程学习',
      component: () => import('@/views/SafeManage/learnSafeCourse.vue'),
    },{
      path: '/commitmentSign',
      name: 'commitmentSign',
      component: () => import('@/views/SafeManage/commitmentSign.vue'),
    },{
      path: '/commitmentList',
      name: 'commitmentList',
      component: () => import('@/views/SafeManage/commitmentList.vue'),
    },{
      path: '/commitmentManage',
      name: 'commitmentManage',
      component: () => import('@/views/SafeManage/commitmentManage.vue'),
    },{
      path: '/trainingSafeLevel',
      name: 'trainingSafeLevel',
      title: '实训室分级管理',
      component: () => import('@/views/Level/trainingSafeLevel.vue'),
    },
    {
      path: '/trainingSafeInfo',
      name: 'trainingSafeInfo',
      title: '实训室安全信息',
      component: () => import('@/views/Level/trainingSafeInfo.vue'),
    },
    {
      path: '/ratingCategorySet',
      name: 'ratingCategorySet',
      title: '分级评分栏目管理',
      component: () => import('@/views/Level/ratingCategorySet.vue'),
    },
    {
      path: '/dangeiSourceSet',
      name: 'dangeiSourceSet',
      title: '危险源管理',
      component: () => import('@/views/Level/dangeiSourceSet.vue'),
    },
    {
      path: '/measuresSet',
      name: 'measuresSet',
      title: '防护措施管理',
      component: () => import('@/views/Level/measuresSet.vue'),
    },
    {
      path: '/levelRuleSet',
      name: 'levelRuleSet',
      title: '分级规则管理',
      component: () => import('@/views/Level/levelRuleSet.vue'),
    },
    {
      path: '/hotQuestions',
      name: 'hotQuestions',
      title: '热门话题管理',
      component: () => import('@/views/SystemSet/hotQuestions.vue'),
    },
    {
      path: '/buildingManage',
      name: 'buildingManage',
      title: '楼宇管理',
      component: () => import('@/views/SystemSet/buildingManage.vue'),
    },
    {
      path: '/knowledgeManage',
      name: 'knowledgeManage',
      title: '知识库管理',
      component: () => import('@/views/SystemSet/knowledgeManage.vue'),
    },
    {
      path: '/agentManage',
      name: 'agentManage',
      title: 'Agent 管理',
      component: () => import('@/views/SystemSet/agentManage.vue'),
    },
    {
      path: '/menuManage',
      name: 'menuManage',
      title: '公共菜单管理',
      component: () => import('@/views/SystemSet/menuManage.vue'),
    },
    {
      path: '/sxjd',
      name: 'sxjd',
      title: '基地数据',
      component: () => import('@/views/DataUp/sxjd.vue'),
    },
    {
      path: '/sxjdzlb',
      name: 'sxjdzlb',
      title: '基地数据',
      component: () => import('@/views/DataUp/sxjdzlb.vue'),
    },
    {
      path: '/sxxmzlb',
      name: 'sxxmzlb',
      title: '实训项目',
      component: () => import('@/views/DataUp/sxxmzlb.vue'),
    },
    {
      path: '/sxjbsjzlb',
      name: 'sxjbsjzlb',
      title: '实训基本项目',
      component: () => import('@/views/DataUp/sxjbsjzlb.vue'),
    },
    {
      path: '/xsjnzszlb',
      name: 'xsjnzszlb',
      title: '学生技能证书',
      component: () => import('@/views/DataUp/xsjnzszlb.vue'),
    },
    {
      path: '/sxgcjxsjzlb',
      name: 'sxgcjxsjzlb',
      title: '实训教学过程',
      component: () => import('@/views/DataUp/sxgcjxsjzlb.vue'),
    },
    {
      path: '/xwsxjd',
      name: 'xwsxjd',
      component: () => import('@/views/DataUp/xwsxjd.vue'),
    },
    {
      path: '/sxsjbsj',
      name: 'sxsjbsj',
      title: '基本数据',
      component: () => import('@/views/DataUp/sxsjbsj.vue'),
    },
    {
      path: '/sxxmsj',
      name: 'sxxmsj',
      title: '实训项目数据',
      component: () => import('@/views/DataUp/sxxmsj.vue'),
    },
    {
      path: '/xnfzjddwfwsj',
      name: 'xnfzjddwfwsj',
      title: '虚拟仿真基地对外服务数据',
      component: () => import('@/views/DataUp/xnfzjddwfwsj.vue'),
    },
    {
      path: '/gzyqsbbb',
      name: 'gzyqsbbb',
      title: '贵重仪器设备表',
      component: () => import('@/views/DataUp/gzyqsbbb.vue'),
    },
    {
      path: '/jxkyyqzjbhqkb',
      name: 'gzyjxkyyqzjbhqkbqsbbb',
      title: '教学科研仪器增减变化情况表',
      component: () => import('@/views/DataUp/jxkyyqzjbhqkb.vue'),
    },
    {
      path: '/sxsjfqkb',
      name: 'sxsjfqkb',
      title: '实验室经费情况报表',
      component: () => import('@/views/DataUp/sxsjfqkb.vue'),
    },
    {
      path: '/jxkyyqsbb',
      name: 'jxkyyqsbb',
      title: '教学科研仪器设备表',
      component: () => import('@/views/DataUp/jxkyyqsbb.vue'),
    },
    {
      path: '/xnfzszzyjbsj',
      name: 'xnfzszzyjbsj',
      title: '虚拟仿真数字资源基本数据',
      component: () => import('@/views/DataUp/xnfzszzyjbsj.vue'),
    },
    {
      path: '/znmjgl',
      name: 'znmjgl',
      title: '智能门禁',
      component: () => import('@/views/IntelAccseeControl/znmjgl.vue'),
    },
    {
      path: '/znhjjk',
      name: 'znhjjk',
      title: '智能环境监控',
      component: () => import('@/views/IntelAccseeControl/znhjjk.vue'),
    },
    {
      path: '/jksxtgl',
      name: 'jksxtgl',
      title: '监控摄像头',
      component: () => import('@/views/IntelAccseeControl/jksxtgl.vue'),
    },
    {
      path: '/smarktLockLink',
      name: 'smarktLockLink',
      title: '智能锁管理',
      component: () => import('@/views/IntelAccseeControl/smarktLockLink.vue'),
    },
    {
      path: '/smarktLockManage',
      name: 'smarktLockManage',
      title: '智能锁管理',
      component: () => import('@/views/IntelAccseeControl/smarktLockManage.vue'),
    },
    {
      path: '/smarktLockApply',
      name: 'smarktLockApply',
      title: '智能锁授权申请',
      component: () => import('@/views/IntelAccseeControl/smarktLockApply.vue'),
    },
    {
      path: '/smarktLockAplplyOper',
      name: 'smarktLockAplplyOper',
      title: '智能锁授权申请审批',
      component: () => import('@/views/IntelAccseeControl/smarktLockAplplyOper.vue'),
    },
    {
      path: '/sxgl',
      name: 'sxgl',
      title: '实训管理',
      component: () => import('@/views/PlanManage/sxgl.vue'),
    },
    {
      path: '/wdsxsq',
      name: 'wdsxsq',
      title: '我的实训申请',
      component: () => import('@/views/PlanManage/wdsxsq.vue'),
    },
    {
      path: '/sxdg',
      name: 'sxdg',
      title: '实训大纲',
      component: () => import('@/views/PlanManage/sxdg.vue'),
    },
    {
      path: '/sxrz',
      name: 'sxrz',
      title: '实训日志',
      component: () => import('@/views/PlanManage/sxrz.vue'),
    },
      // , {
      //   path: '/demoEchart',
      //   name: 'Echart',
      //   navTitle: 'Echart报表',
      //   index: 1,
      //   navIcon: 'el-icon-s-help',
      //   component: () => import( '@/views/Demo/demoEchart.vue')
      // }, {
      //   path: '/demoImgUp',
      //   name: 'ImgUpLoad',
      //   navTitle: '图片上传',
      //   index: 2,
      //   navIcon: 'el-icon-picture',
      //   component: () => import( '@/views/Demo/demoImgUp.vue')
      // },
      //  {
      //   path: '/demoList',
      //   name: 'dataList',
      //   navTitle: '表格',
      //   index: 3,
      //   isLeaf: true,
      //   navIcon: 'el-icon-menu',
      //   title: '数据表格',
      //   icon: 'el-icon-s-grid',
      //   component: () => import( '@/views/Demo/demoList.vue'),
      // }, {
      //   path: '/demoForm',
      //   name: 'dataListForm',
      //   index: 4,
      //   pindex: 3,
      //   title: '表单提交',
      //   icon: 'el-icon-s-order',
      //   component: () => import( '@/views/Demo/demoForm.vue')
      // }
    ]
  }, {
    path: '/dataReportCenter',
    name: 'dataReportCenter',
    title: '数据统计报表中心',
    component: () => import('@/views/DataReport/dataReportCenter.vue'),
  },
  {
    path: '/loginTrain',
    name: 'LoginTrain',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/StudentH5/loginTrain.vue')
  },
  {
    path: '/studentSignForStu',
    name: 'studentSignForStu',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/StudentH5/studentSign.vue')
  },
  {
    path: '/changeTrains',
    name: 'changeTrains',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/changeTrains.vue')
  },
  {
    path: '/dataCenter',
    name: 'dataCenter',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/DataScreen/dataCenter.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/login.vue')
  },
  {
    path: '/login/:key',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/login.vue')
  },
  {
    path: '/ChangePassword',
    name: 'ChangePassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/ChangePassword.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
